import programs from './programs';
import programContents from './programContents';

export default {
  ...programs,
  ...programContents,
};
